import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AppContext } from "../context/index";

interface PublicRoutesProps {
  children: JSX.Element;
}

export const PublicRoutes: React.FC<PublicRoutesProps> = ({
  children,
}): React.ReactElement => {
  const {
    appState: { user },
  } = useContext(AppContext);
  
  if (user) {
    return <Navigate to="/" />;
  }

  return children;
};